import CONSTANT from 'modules/constant'
import type {
  OtherBrandUsersListProps,
  PaginationProps,
} from 'modules/types'
import { API, download, headers } from './api'

const OtherBrandModelAPI = API.injectEndpoints({
  endpoints: (builder) => ({
    getOtherBrandUsersList: builder.mutation<PaginationProps<OtherBrandUsersListProps>, FormData>({
      query: (body) => ({
        url: CONSTANT.URL_OTHER_BRAND_USERS_LIST,
        method: 'POST',
        headers: headers({ useContentType: false }),
        body: body,
        formData: true
      }),
    }),
    downloadOtherBrandUsers: builder.mutation<PaginationProps<OtherBrandUsersListProps>, FormData>({
      query: (body) => ({
        url: CONSTANT.URL_OTHER_BRAND_USERS_DOWNLOAD,
        method: 'POST',
        headers: headers({ useContentType: false }),
        responseHandler: download,
        body: body,
        formData: true
      })
    }),
  })
})

export const {
  useGetOtherBrandUsersListMutation,
  useDownloadOtherBrandUsersMutation,
} = OtherBrandModelAPI
